import { requiredUuidString } from '../zod-helpers/index.js';
/** An Activity page's `before`: the previous page's `olderCursor` (a revision id), or nothing for the newest page. */
export const activityCursorSchema = requiredUuidString('Activity cursor is required.', 'Invalid activity cursor.').nullish();
//# sourceMappingURL=activity-cursor.js.map